import { RemoteCourseUpdate } from 'data/usecases';
import { makeApiUrlCourse } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCourseUpdate = (): RemoteCourseUpdate => {
  return new RemoteCourseUpdate(makeApiUrlCourse(), makeAxiosHttpClient());
};
